import { render } from "./accounts.vue?vue&type=template&id=2e1e431b"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
script.render = render

export default script